if (!customElements.get('section-announcement-bar')) {
  class TG_SectionAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this._cycleInterval = null;
      this._currentIndex = 0;
      this._items = [];
      this._onResizeBound = this._onResize.bind(this);
    }

    connectedCallback() {
      this.delegateElement = new themegoal.libs.Delegate(this);
      this.options = JSON.parse(this.getAttribute('data-section-settings'));

      try {
        if (this.options['closeable'] && sessionStorage.getItem('AnnoucementClosed') === null) {
          this._openAnnoucement();
        }
      } catch (error) {}

      this._bindEventsListeners();
      this._items = Array.from(this.querySelectorAll('.Announcement__Item'));

      if (this._isMobile()) {
        this._startCycle();
      }

      window.addEventListener('resize', this._onResizeBound);
    }

    disconnectedCallback() {
      if (this.delegateElement) this.delegateElement.destroy();
      if (this._cycleInterval) clearInterval(this._cycleInterval);
      window.removeEventListener('resize', this._onResizeBound);
    }

    _bindEventsListeners() {
      this.delegateElement.on('click', '[data-action="close-annoucement"]', this._closeAnnoucement.bind(this));
    }

    _openAnnoucement() {
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.style.setProperty('--tg-announcement-bar-height', document.getElementById('AnnouncementBar').offsetHeight + 'px');
    }

    _closeAnnoucement() {
      sessionStorage.setItem('AnnoucementClosed', 'true');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.style.setProperty('--tg-announcement-bar-height', '0px');
    }

    _isMobile() {
      return window.innerWidth <= 749;
    }

    _startCycle() {
      if (this._cycleInterval || this._items.length < 2) return;

      // Show first item immediately
      this._items[0].classList.add('is-active');

      this._cycleInterval = setInterval(() => {
        var nextIndex = (this._currentIndex + 1) % this._items.length;
        var current = this._items[this._currentIndex];
        var next = this._items[nextIndex];

        // Fade out current
        current.classList.remove('is-active');

        // After current fades out, fade in next with flash
        setTimeout(() => {
          next.classList.add('is-active', 'is-flash');

          // Remove flash after it registers
          setTimeout(() => {
            next.classList.remove('is-flash');
          }, 600);

        }, 700);

        this._currentIndex = nextIndex;
      }, 5000);
    }

    _stopCycle() {
      if (this._cycleInterval) {
        clearInterval(this._cycleInterval);
        this._cycleInterval = null;
      }
      this._items.forEach(item => {
        item.classList.remove('is-active', 'is-flash');
      });
    }

    _onResize() {
      if (this._isMobile()) {
        this._startCycle();
      } else {
        this._stopCycle();
      }
    }
  }

  customElements.define('section-announcement-bar', TG_SectionAnnouncementBar);
}